export default "__VITE_ASSET__4ef8b5ad__"